export enum EngineProductionLaw {
    OFF, IDLE, LOW, REDUCED, OPERATIONAL, MAX
}
